__turbopack_context__.v({
  "breadcrumb-link": "FaqBreadcrumbs-module-scss-module__Ib2U7a__breadcrumb-link",
  "breadcrumbs": "FaqBreadcrumbs-module-scss-module__Ib2U7a__breadcrumbs",
  "category-arrow": "FaqBreadcrumbs-module-scss-module__Ib2U7a__category-arrow",
});
